import { useSetDraftCJSeance } from 'containers/CahierJournal/atoms';
import { useEffect, useMemo } from 'react';
import { FormSpy, useFormState } from 'react-final-form';
import _debounce from 'lodash-es/debounce';

// we define a threshold and a debounce to prevent overusing the localStorage
const THRESHOLD_MILLIS = 5000;
const DEBOUNCE_MILLIS = 800;

type Props = {
  debounce: number;
  onSave: (v: any) => void;
};

function AutoBackup({ debounce, onSave }: Props) {
  const { values, dirty } = useFormState();
  const mountedAt = useMemo(() => Date.now(), []);

  useEffect(() => {
    const timeElapsed = Date.now() - mountedAt;
    if (dirty && timeElapsed >= THRESHOLD_MILLIS) {
      const debouncedSave = _debounce(() => onSave(values), debounce);
      debouncedSave();
      return () => debouncedSave.cancel();
    }
    return undefined;
  }, [values]);
  return null;
}

export function AutoBackupCJSeanceForm() {
  const setDraftCJSeance = useSetDraftCJSeance();
  return (
    <FormSpy subscription={{ values: true, modified: true }}>
      {() => (
        <AutoBackup
          debounce={DEBOUNCE_MILLIS}
          onSave={v => setDraftCJSeance(JSON.stringify(v))}
        />
      )}
    </FormSpy>
  );
}
